import type { CropAttribute, CropAttributeSummary } from '../../models/Crop';

export type AttributeFormValues = {
  name: string;
  description: string;
  options: Array<{
    id?: number | string;
    title: string;
    code: string;
  }>;
};

export const mapAttributeToFormValues = (attribute: CropAttribute | CropAttributeSummary): AttributeFormValues => {
  const sortedOptions = [...(attribute.options || [])].sort((a, b) => {
    const left = a.sortOrder ?? Number.MAX_SAFE_INTEGER;
    const right = b.sortOrder ?? Number.MAX_SAFE_INTEGER;
    if (left === right) return String(a.title).localeCompare(String(b.title));
    return left - right;
  });

  return {
    name: attribute.name,
    description: attribute.description ?? '',
    options: sortedOptions.map((option) => ({
      id: option.id,
      title: option.title,
      code: option.code,
    })),
  };
};

export const normalizeAttributeFormValues = (values: Partial<AttributeFormValues>): AttributeFormValues => ({
  name: typeof values.name === 'string' ? values.name : '',
  description: typeof values.description === 'string' ? values.description : '',
  options: Array.isArray(values.options)
    ? values.options.map((option) => ({
        id: option?.id,
        title: option?.title ?? '',
        code: option?.code ?? '',
      }))
    : [],
});